$(document).ready(function () {
    function buildCollectionUrl({ sortBy = null, page = null }) {
        const url = new URL(window.location.href);

        if (sortBy) {
            url.searchParams.set('sort_by', sortBy);
        } else {
            url.searchParams.delete('sort_by');
        }

        if (page) {
            url.searchParams.set('page', page);
        } else {
            url.searchParams.delete('page');
        }

        return url.pathname + url.search;
    }

    function getCurrentSortBy() {
        const params = new URLSearchParams(window.location.search);
        return params.get('sort_by');
    }

    function fetchCollection(url) {
        history.pushState(null, '', url);

        $.get(url, function (response) {
            const $html = $(response);

            const newGrid = $html.find('.collection-content').html();
            $('.collection-content').html(newGrid);

            const sortBy = getCurrentSortBy();

            $('.collection-sorting select').each(function () {
                if (!sortBy) {
                    this.selectedIndex = 0; // default option
                } else {
                    $(this).find('option').each(function () {
                        if (this.value.includes(`sort_by=${sortBy}`)) {
                            this.selected = true;
                        }
                    });
                }
            });

            $('html, body').animate({ scrollTop: 0 }, 600);
        });
    }

    $('.short-description').on('click', function () {
        $(this).height('auto');
    });

    $(document).on('change', '.collection-sorting select', function (e) {
        const sortBy = $(this).find(':selected').val().split('sort_by=')[1] || null;
        const url = buildCollectionUrl({ sortBy, page: null });

        fetchCollection(url);
    });

    $(document).on('click', '.collection-pagination a', function (e) {
        const href = $(this).attr('href');
        if (!href) return;
        e.preventDefault();

        fetchCollection(href);
    });
});